(function($) {
  // ES: tag Safari (desktop) so we can apply Safari-specific quickview scrolling fixes
  (function(){
    try{
      var ua = navigator.userAgent || '';
      var isSafari = ua.indexOf('Safari') !== -1 &&
                     ua.indexOf('Chrome') === -1 &&
                     ua.indexOf('Chromium') === -1 &&
                     ua.indexOf('Android') === -1;
      if (isSafari) document.documentElement.classList.add('es-safari');
    }catch(e){}
  })();

// ES: removed debug info log
  function showPopup(selector) {
    $(selector).addClass('active');
    document.dispatchEvent(new CustomEvent("swym:qv-loaded"));
  } window.showPopup=showPopup;

  function hidePopup(selector) {
    $(selector).removeClass('active');

    // ES: When closing quickview, unlock page scroll (prevents double scrollbars)
    if (selector === '.quickview-product' || selector === '.tshopify-popup') {
      $('html,body').removeClass('es-qv-open');
    }
  }

  function qtyProduct() {  
    $('.qtyplus').click(function(e){
      var fieldName = $(this).attr('data-field');
      var currentVal = parseInt($('input[name='+fieldName+']').val());

      if (!isNaN(currentVal)) {
        $('input[name='+fieldName+']').val(currentVal + 1);
      } else {
        $('input[name='+fieldName+']').val(1);
      }
      e.preventDefault();
    });

    $(".qtyminus").click(function(e) {

      var fieldName = $(this).attr('data-field');
      var currentVal = parseInt($('input[name='+fieldName+']').val());
      if (!isNaN(currentVal) && currentVal > 1) {
        $('input[name='+fieldName+']').val(currentVal - 1);    }
      else {
        $('input[name='+fieldName+']').val(1);
      }
      e.preventDefault();
    });
  }
  window.qtyProduct=qtyProduct;

  function doAjaxAddToCart(variant_id, quantity, title, image) {

    $.ajax({
      type: "post",
      url: "/cart/add.js",
      data: 'quantity=' + quantity + '&id=' + variant_id,
      dataType: 'json',
      beforeSend: function() {
        showPopup('.loading');
      },
      success: function(msg) {

  $('.tshopify-popup').removeClass('active');
  hidePopup('.quickview-product');

  // ES: Open minicart after QuickView add-to-cart (match PDP behavior)
  function esOpenMiniCart() {
    try {
      if ($('.filter-to-left').hasClass('active')) {
        $('.filter-to-left').removeClass('active');
      }
      $('.js-minicart').addClass('active');
      $('.bg-minicart').addClass('active');
      $('body').addClass('es-minicart-open');
    } catch (e) {
      try { $('.js-call-minicart').first().trigger('click'); } catch (e2) {}
    }
  }
  esOpenMiniCart();

  // ES: After QuickView add-to-cart, highlight the newly added item in minicart (subtle premium cue)
  var esAddedVariantId = variant_id;
  function esFlashMiniCartItem(vid) {
    try {
      if (!vid) return;
      var $drawer = $('.js-minicart');
      if (!$drawer.length) return;

      // Prefer matching the exact variant (template exposes data-variant-id)
      var $target = $drawer.find('[data-variant-id="' + vid + '"]').first();

      // Fallback: first visible line item
      if (!$target.length) {
        $target = $drawer.find('.ajaxcart__product, .minicart__item, .cart__row, li').filter(':visible').first();
      }
      if (!$target.length) return;

      // Restart animation if it was applied recently
      $target.removeClass('es-cart-item-flash');
      void $target[0].offsetWidth; // force reflow
      $target.addClass('es-cart-item-flash');

      // Cleanup class after animation
      setTimeout(function () { try { $target.removeClass('es-cart-item-flash'); } catch (e) {} }, 950);
    } catch (e) {}
  }

  // ES: Refresh minicart content without requiring a page refresh.
  // Prefer ajaxCart.load() (it updates counts, price, bindings), but provide a safe fallback.
  try {
    $('body').one('ajaxCart.afterCartLoad', function () {
      esOpenMiniCart();
      setTimeout(function(){ esFlashMiniCartItem(esAddedVariantId); }, 60);
    });

    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      window.ajaxCart.load();
    } else {
      $.getJSON('/cart.js?ts=' + Date.now())
        .done(function (cart) { try { tbuildCart(cart); } catch (e3) {} setTimeout(function(){ esFlashMiniCartItem(esAddedVariantId); }, 60); })
        .fail(function () {
          try { Shopify.getCart(function (cart) { try { tbuildCart(cart); } catch (e4) {} setTimeout(function(){ esFlashMiniCartItem(esAddedVariantId); }, 60); }); } catch (e5) {}
        });
    }
  } catch (e6) {
    try { Shopify.getCart(function (cart) { try { tbuildCart(cart); } catch (e7) {} setTimeout(function(){ esFlashMiniCartItem(esAddedVariantId); }, 60); }); } catch (e8) {}
  }

  // ES: Always close the loading overlay after add-to-cart
  try { hidePopup('.loading'); } catch (e9) {}
  try { $('.loading').removeClass('loaded-content'); } catch (e10) {}
},
      error: function(xhr, text) {
        hidePopup('.loading');
        $('.error-message').text($.parseJSON(xhr.responseText).description);
        showPopup('.error-popup');
      }
    });
  }window.doAjaxAddToCart=doAjaxAddToCart;

  function tbuildCart(cart) {
    // Start with a fresh cart div
    var $cartContainer = $('.enj-minicart-ajax');
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
            // ES: Consistent empty-state (match snippets/minicart.liquid)
            var cfg = (window.ajaxCartConfig || {});
            var emptyText = cfg.emptyText || "Your shopping cart is empty";
            var shopNowText = cfg.shopNowText || "START SHOPPING";
            var shopNowUrl = cfg.shopNowUrl || "/";
            $cartContainer.append(
              '<div class="list_product_minicart empty">' +
                '<div class="empty-product_minicart">' +
                  '<p class="mb-0">' + emptyText + '</p>' +
                  '<a href="' + shopNowUrl + '" class="to-cart">' + shopNowText + '</a>' +
                '</div>' +
              '</div>'
            );
      try { $('body').removeClass('drawer--is-loading'); $('body').trigger('ajaxCart.afterCartLoad', cart); } catch (e0) {}
      // ES: keep header cart dot in sync for empty state
      try {
        $('.js-number-cart').removeClass('active');
        document.documentElement.classList.remove('es-cart-has-items');
        if (window.localStorage) localStorage.setItem('es_cart_has_items', '0');
      } catch (e) {}
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Remove internal LensAdvisor properties so the mini cart doesn't show debug data
    function cleanProperties(properties) {
      if (!properties) return null;
      var clean = {};
      var hideKeyExact = {
        'bundleId': true,
        '_bundleId': true,
        '_productType': true,
        'productType': true,
        '_unique_identifier': true,
        'unique_identifier': true,
        '_base_variant_id': true,
        'base_variant_id': true,
        '_lens_variant_ids': true,
        '_apply_discount': true,
        '_addOns': true,
        '_addons': true,
        '_parent': true,
        '_child': true
      };

      for (var k in properties) {
        if (!properties.hasOwnProperty(k)) continue;
        var v = properties[k];
        if (v === null || v === undefined || v === '') continue;
        if (hideKeyExact[k]) continue;
        var lk = (k || '').toString().toLowerCase();
        if (lk.indexOf('bundle') !== -1 && lk.indexOf('id') !== -1) continue;
        if (lk.indexOf('unique') !== -1 || lk.indexOf('identifier') !== -1) continue;
        if (lk.indexOf('base_variant') !== -1) continue;
        if (lk.indexOf('producttype') !== -1) continue;
        if (lk.indexOf('lens_variant') !== -1) continue;
        if (lk.indexOf('lensadvisor') !== -1 || lk.indexOf('lensadvizor') !== -1) continue;

        // Remove leading underscores from display labels.
        var dk = (k || '').toString().replace(/^_+/, '');
        if (!dk) continue;
        clean[dk] = v;
      }

      return Object.keys(clean).length ? clean : null;
    }

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cleanProperties(cartItem.properties),
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, ajaxCartConfig.moneyFormat),
        vendor: cartItem.vendor
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, ajaxCartConfig.moneyFormat)
    }

    $cartContainer.append(template(data));
    $('.enj-cartcount').html(cart.item_count);
    $('body').removeClass('drawer--is-loading');
    $('body').trigger('ajaxCart.afterCartLoad', cart);
    $('.js-call-minicart').click();
    // ES: keep header cart dot stable & cache state for navigation
    try {
      $('.js-number-cart').addClass('active');
      document.documentElement.classList.add('es-cart-has-items');
      if (window.localStorage) localStorage.setItem('es_cart_has_items', '1');
    } catch (e) {}
  };

  function convertToSlug(text) {
    return text.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
  } window.convertToSlug=convertToSlug;


  $(document).ready(function() {
    if ($(window).width() < 992 ) {
      responsiveQuickview();
    } else {
      quickView();
    }
    $(window).resize(function(){
      if ($(window).width() < 992 ) {
        responsiveQuickview();
      } else {
        quickView();
      }
    })

  });

  // Close popups when clicking the overlay / outside area
  // - .overlay: legacy popup overlay
  // - .overlay-quickview: quickview modal backdrop
  $(document).on('click','.overlay,.overlay-quickview,.continue-shopping, .close-window', function() {
    // Keep legacy behavior but also ensure quickview closes.
    hidePopup('.tshopify-popup');
    hidePopup('.quickview-product');

    // Eyeshells: the same .close-window button is also used by the Ajax add-to-cart popup
    // so ensure the add-to-cart popup closes too.
    if ($('.engo-popup.active').length) {
      $('.engo-popup').removeClass('active');
    }

    setTimeout(function(){
      $('.loading').removeClass('loaded-content');
    },500);
    return false;
  });


  function responsiveQuickview() {
    if ($(window).width() < 992 ) {
      $('.engoj_btn_quickview').each(function(){
        var linkProduct='/products/' + $(this).attr('data-id');
        $(this).attr('href',linkProduct);    
      })
    } else {
      $('.engoj_btn_quickview').attr('href','javascript:void(0)');
    }
    $(window).resize(function(){
      if ($(window).width() < 992 ) {
        $('.engoj_btn_quickview').each(function(){
          var linkProduct='/products/' + $(this).attr('data-id');
          $(this).attr('href',linkProduct);    
        })
      } else {
        $('.engoj_btn_quickview').attr('href','javascript:void(0)');
      }
    })
  }

  function quickView() {
    // Delegate binding so Quick View works for elements injected after DOM ready
    // (e.g. product recommendations / related products slick sliders).

	    // Shared opener so we can call it from multiple binding strategies.
	    // Also prevents double-open (e.g. if both pointer and click handlers fire).
	    function esOpenQuickview(btnEl) {
	      if (!btnEl) return;
	      // Quickview is disabled on mobile/tablet in this theme.
	      if ($(window).width() < 992) return;

	      var now = Date.now();
	      if (btnEl.__es_qv_opened_at && (now - btnEl.__es_qv_opened_at) < 450) return;
	      btnEl.__es_qv_opened_at = now;

	      var $btn = $(btnEl);
	      var id = $btn.data('id');
	      if (!id) return;

	      showPopup('.loading');

	      // Rating badge may be absent in some contexts (e.g. related products).
	      var r = $btn.closest('.product-info').find('.spr-badge').attr('data-rating');
	      var rating = (parseFloat(r || 0) * 20) + "%";

	      Shopify.getProduct(id, function(product) {
	        var template = $('#quick-view').html();
	        $('.quickview-product').html(template);
	        var quickview = $('.quickview-product');
	        quickview.find('.product-name a').html(product.title).attr('href', product.url);
	        quickview.find('.spr-badge .spr-active').css({"width": rating});
	        quickview.find('.star-rating .shopify-product-reviews-badge').attr('data-id',product.id)
	        
if (quickview.find('.des').length > 0) {
    var description = product.description;
    var frameSizeIndex = description.indexOf('<h2 class="font-black font-small-xs color-gray-darker margin-top-25-xs">Maße</h2>');

    if (frameSizeIndex !== -1) {
        description = description.substring(frameSizeIndex);
        description = description.replace('<h2 class="font-black font-small-xs color-gray-darker margin-top-25-xs">Maße</h2>', ''); // 用于移除 "Maße"
    }

    quickview.find('.des').html(description);

    // 查找到两个 <ul>
    var $ul1 = quickview.find('.list-unstyled').first();
    var $ul2 = quickview.find('.list-unstyled').last();

    // 将第二个<ul>的所有<li>元素追加到第一个<ul>
    $ul2.children('li').appendTo($ul1);

    // 在每个 <li> 前添加对钩图标
$ul1.children('li').prepend('<i class="fas fa-glasses" style="margin-right: 10px;"></i>');


    // 移除第二个<ul>以及它的父元素<div>
    $ul2.parent('.right-section').remove();

    // 修改 $ul1 的父元素的类，使其占用全宽度并减少图标与文本之间的间距
    $ul1.parent().removeClass('col-sm-6').addClass('col-sm-12').find('li').css('margin-top', '5px');  
  
    // 假设父元素原来有 'col-sm-6' 这个类

} else {
    quickview.find('.des').remove();
}


	        quickview.find('.price').html(Shopify.formatMoney(product.price, window.money_format));
	        quickview.find('.product-inner').attr('id', 'product-' + product.id);
	        quickview.find('.variants').attr('id', 'product-actions-' + product.id);
	        quickview.find('.variants select').attr('id', 'product-select-' + product.id);

	        if (product.compare_at_price > product.price) {
	          quickview.find('.compare-price').html(Shopify.formatMoney(currencyConverter(product.compare_at_price_max), window.money_format)).show();
	          quickview.find('.price').addClass('on-sale');
	        } else {
	          quickview.find('.compare-price').html('');
	          quickview.find('.price').removeClass('on-sale');
	        }

	        // out of stock
	        if (!product.available) {
	          quickview.find("select, input, .total-price, .dec, .inc, .variants label").remove();
	          quickview.find(".btn-addToCart").text('unavailable').addClass('disabled').attr("disabled", "disabled");
	        } else {
	          quickview.find('.total-price span').html(Shopify.formatMoney(currencyConverter(product.price), window.money_format));
	          tshopifyQuickview.createQuickViewVariantsSwatch(product, quickview);
	        }

	        qtyProduct();
	        tshopifyQuickview.quickViewSlider(product, quickview);
	        tshopifyQuickview.initQuickviewAddToCart();

	        $('.quickview-product').addClass('active');
	        // ES: lock page scroll while quickview is open (prevents double scrollbars)
	        $('html,body').addClass('es-qv-open');
	        // Remove Safari/iOS default title tooltips inside quickview image area
	        if (window.esStripQuickviewImageTitles) {
	          window.esStripQuickviewImageTitles(document.querySelector('.quickview-product'));
	        }
	        $('.loading').addClass('loaded-content');

	        if ($('.quickview-product .total-price').length > 0) {
	          $('.quickview-product span[class=qtyplus]').on('click', tshopifyQuickview.updatePricingQuickview);
	          $('.quickview-product span[class=qtyminus]').on('click', tshopifyQuickview.updatePricingQuickview);
	        }
	      });
	    }
	    $(document)
	      .off('click.quickview', '.engoj_btn_quickview')
	      .on('click.quickview', '.engoj_btn_quickview', function(e) {
	        e.preventDefault();
	        esOpenQuickview(this);
	        return false;
	      });

	    /**
	     * ES FIX: In some Slick configurations (e.g. related products carousel), Slick may prevent
	     * the click event from bubbling up to `document`, which can break delegated handlers.
	     * We bind a direct click handler for related slider quickview buttons.
	     */
		    function esBindRelatedQuickviewDirect(){
	      var $btns = $('.es-related-slider .engoj_btn_quickview');
	      if (!$btns.length) return;

	      // Prevent slick drag-start when clicking the Quick View icon.
	      $btns.off('mousedown.esqv touchstart.esqv pointerdown.esqv')
	        .on('mousedown.esqv touchstart.esqv pointerdown.esqv', function(ev){
	          ev.stopPropagation();
	        });

		      $btns.off('click.esqv').on('click.esqv', function(ev){
		        ev.preventDefault();
		        // Prevent double-open if the delegated handler also fires.
		        ev.stopPropagation();
		        esOpenQuickview(this);
		        return false;
		      });
	    }

		    // Pointer fallback: in some browsers/trackpads, a draggable carousel can suppress `click`.
		    // We open on a "tap" style pointer interaction (small movement) within the related slider.
		    (function esRelatedQuickviewPointerFallback(){
		      if (window.__es_related_qv_pointer_fallback) return;
		      window.__es_related_qv_pointer_fallback = true;
		      var start = null;
		      var startEl = null;
		      document.addEventListener('pointerdown', function(ev){
		        var btn = ev.target && ev.target.closest ? ev.target.closest('.es-related-slider .engoj_btn_quickview') : null;
		        if (!btn) return;
		        startEl = btn;
		        start = { x: ev.clientX, y: ev.clientY };
		      }, true);
		      document.addEventListener('pointerup', function(ev){
		        if (!startEl || !start) return;
		        var btn = ev.target && ev.target.closest ? ev.target.closest('.es-related-slider .engoj_btn_quickview') : null;
		        var sEl = startEl;
		        var s = start;
		        startEl = null;
		        start = null;
		        if (!btn || btn !== sEl) return;
		        var dx = Math.abs((ev.clientX || 0) - (s.x || 0));
		        var dy = Math.abs((ev.clientY || 0) - (s.y || 0));
		        if (dx > 6 || dy > 6) return; // treat as drag
		        // Let the shared opener handle the mobile guard and double-open prevention.
		        ev.preventDefault();
		        ev.stopPropagation();
		        esOpenQuickview(btn);
		      }, true);
		    })();

	    // Bind now and re-bind when Slick initializes/re-initializes.
	    esBindRelatedQuickviewDirect();
	    $(document)
	      .off('init.esqv reInit.esqv', '.es-related-slider')
	      .on('init.esqv reInit.esqv', '.es-related-slider', function(){
	        esBindRelatedQuickviewDirect();
	      });
  } window.quickView=quickView;

  var tshopifyQuickview = {

    /* =========================================================
     * ES Quickview Hover Swap (ES-like)
     * After selecting a color, hovering the big image shows the
     * next image within that color's image group.
     * ========================================================= */
    initQuickviewHoverSwap: function(product, quickviewTemplate) {
      try {
        if (!product || !quickviewTemplate || !quickviewTemplate.length) return;

        // Cache product on the quickview root so selectCallbackQuickview can access it.
        try { quickviewTemplate.data('esQvProduct', product); } catch(e) {}
        var $wrap = quickviewTemplate.find('.featured-image a.product-photo').first();
        if (!$wrap.length) {
          // fallback if markup changes
          $wrap = quickviewTemplate.find('.featured-image').first();
        }
        if (!$wrap.length) return;
$wrap.addClass('es-pdp-hover-swap');

        var $overlay = $wrap.find('.es-pdp-hover-alt').first();
        if (!$overlay.length) {
          $overlay = $('<img class="es-pdp-hover-alt" alt="" aria-hidden="true" loading="lazy" draggable="false" />');
          $wrap.append($overlay);
        }

        var state = quickviewTemplate.data('esQvHoverSwap') || {};
        state.wrap = $wrap;
        state.overlay = $overlay;
        state.lastAlt = state.lastAlt || '';
        state.timer = null;
        state.delay = 160;
        state.desktopMin = 992;

        state.normalize = function(url){
          if(!url) return '';
          var clean = String(url).replace(/^https?:/,'').split('?')[0];
          // remove common Shopify size suffixes
          clean = clean
          .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|1024x1024|2048x2048|master)(?=\.)/i,'')
          // numeric size suffixes like _360x, _360x360, _1200x, _1200x800
          .replace(/_(\d+)(x\d+)?x?(?=\.)/i,'');
          return clean;
        };

        state.shouldEnable = function(){
          try {
            if (window.innerWidth < state.desktopMin) return false;
            if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) return true;
            return false;
          } catch(e) {
            return window.innerWidth >= state.desktopMin;
          }
        };

        state.findIndex = function(list, src){
          if (!list || !list.length || !src) return -1;
          var n = state.normalize(src);
          if (!n) return -1;
          var nFile = n.split('/').pop();
          for (var i = 0; i < list.length; i++) {
            var ni = state.normalize(list[i]);
            if (!ni) continue;
            if (ni === n) return i;
            // Fallback: compare filenames (Shopify URLs can differ by CDN params / domains)
            if (nFile) {
              var niFile = ni.split('/').pop();
              if (niFile && niFile === nFile) return i;
            }
          }
          return -1;
        };

        // In Quickview we prefer using the DOM thumbnail list (data-image)
        // because it's already in the exact display order + size ('grande').
        // Fallback to product.images if the DOM isn't ready yet.
        state.toGrande = function(url){
          if (!url) return '';
          try {
            if (window.Shopify && Shopify.resizeImage) return Shopify.resizeImage(url, 'grande');
          } catch(e) {}
          return url;
        };

        state.getImages = function(){
          try {
            var dom = [];
            quickviewTemplate.find('.more-views .es-thumb-track .item a[data-image], .more-views .owl-carousel .item a[data-image]').each(function(){
              try { if (window.jQuery && jQuery(this).closest('.slick-cloned').length) return; } catch(e) {}
              var u = this.getAttribute('data-image');
              if (u) dom.push(u);
            });
            if (dom.length) return dom;
          } catch(e) {}
          var imgs = (product && product.images) ? product.images.slice() : [];
          try {
            imgs = imgs.map(state.toGrande);
          } catch(e) {}
          return imgs;
        };

        state.getImagesSig = function(images){
          if (!images || !images.length) return '0';
          var first = state.normalize(images[0] || '');
          var last = state.normalize(images[images.length - 1] || '');
          return String(images.length) + '|' + first + '|' + last;
        };


        state.getCurrentVariant = function(){
          try {
            var id = quickviewTemplate.find('select[name=id]').val() || quickviewTemplate.find('input[name=id]').val();
            if (!id) return null;
            id = String(id);
            for (var i = 0; i < (product.variants || []).length; i++) {
              if (String(product.variants[i].id) === id) return product.variants[i];
            }
          } catch(e) {}
          return null;
        };

        state.getColorIndex = function(){
          try {
            var opts = product.options || [];
            for (var i = 0; i < opts.length; i++) {
              var name = (opts[i] && typeof opts[i] === 'object' && opts[i].name) ? opts[i].name : opts[i];
              if (/Color|Colour/i.test(String(name || ''))) return i;
            }
          } catch(e) {}
          return -1;
        };

        // Shopify product JSON can represent options as:
        // - variant.options[] (array)
        // - variant.option1/option2/option3 (strings)
        // This helper makes our logic robust across both.
        state.getVariantOption = function(v, idx){
          try {
            if (!v || idx < 0) return null;
            if (v.options && v.options.length > idx) return v.options[idx];
            var k = 'option' + (idx + 1);
            if (v[k]) return v[k];
            if (v.option_values && v.option_values.length > idx) return v.option_values[idx];
          } catch(e) {}
          return null;
        };

        // Read the currently selected color value (works even if variant.options is missing).
        state.getSelectedColorValue = function(){
          try {
            var colorIdx = state.getColorIndex();
            if (colorIdx < 0) return null;

            var v = state.getCurrentVariant();
            var c = state.getVariantOption(v, colorIdx);
            if (c) return String(c).trim();

            // Prefer the swatch radio group (always present in this theme)
            var $checked = quickviewTemplate
              .find('.swatch[data-option-index="' + colorIdx + '"] input[type="radio"]:checked')
              .first();
            if ($checked.length) {
              var val = $checked.val();
              if (val) return String(val).trim();
            }

            // Fallback: option selector dropdowns
            var $sel = quickviewTemplate.find('.single-option-selector').eq(colorIdx);
            if ($sel && $sel.length) {
              var sv = $sel.val();
              if (sv) return String(sv).trim();
            }
          } catch(e) {}
          return null;
        };


	        // Build "color blocks" using ONE start index per color (the earliest featured image index for that color).
	        // Why: many catalogs have multiple variants (e.g. sizes) sharing the same color. Those variants can
	        // reference different featured images within the SAME color image group. If we treat every featured image
	        // as a "start", the boundary can collapse to a single image and hover-swap will never activate.
	        state.buildColorBlocks = function(colorIdx){
	          var images = state.getImages();
	          var startsByColor = {}; // colorLower -> { color, start }

	          function addStart(color, idx){
	            if (idx < 0) return;
	            if (!color) return;
	            color = String(color).trim();
	            if (!color) return;
	            var key = color.toLowerCase();
	            if (!startsByColor[key] || idx < startsByColor[key].start) {
	              startsByColor[key] = { color: color, start: idx };
	            }
	          }

	          // 1) Prefer the swatch DOM, because it represents the real "color set"
	          // in this theme (some products have multiple variants per color, which
	          // can confuse variant-based grouping).
	          try {
	            var $sw = quickviewTemplate.find('.swatch[data-option-index="' + colorIdx + '"]').first();
	            if ($sw.length) {
	              $sw.find('input[type="radio"]').each(function(){
	                var $in = jQuery(this);
	                var colorVal = ($in.val() || '').toString().trim();
	                if (!colorVal) return;

	                // Find associated label and parse its background-image URL
	                var id = $in.attr('id');
	                var $lab = id ? $sw.find('label[for="' + id + '"]').first() : jQuery();
	                var bg = '';
	                if ($lab.length) bg = ($lab.css('background-image') || '');
	                var url = '';

	                if (bg && bg !== 'none') {
	                  // bg looks like: url("https://...") or url(//...)
	                  url = bg.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
	                }

	                if (!url) {
	                  // fallback: inline style might have background-image:url(...)
	                  var st = ($lab.attr('style') || '');
	                  var m = st.match(/background-image\s*:\s*url\(([^)]+)\)/i);
	                  if (m && m[1]) url = m[1].replace(/["']/g,'').trim();
	                }

	                if (!url) return;

	                url = state.toGrande(url);
	                var idx = state.findIndex(images, url);
	                addStart(colorVal, idx);
	              });
	            }
	          } catch(e) {}

	          // 2) Fallback: use variants featured_image if swatch parsing didn't yield enough colors
	          if (Object.keys(startsByColor).length < 1) {
	            (product.variants || []).forEach(function(v){
	              if (!v || colorIdx < 0) return;
	              var color = state.getVariantOption(v, colorIdx);
	              if (!color) return;
	              color = String(color).trim();

	              var fi = '';
	              if (v.featured_image && v.featured_image.src) fi = v.featured_image.src;
	              else if (v.featured_image) fi = v.featured_image;
	              else if (v.image && v.image.src) fi = v.image.src;
	              if (!fi) return;

	              fi = state.toGrande(fi);
	              var idx = state.findIndex(images, fi);
	              addStart(color, idx);
	            });
	          }

	          var blocks = Object.keys(startsByColor)
	            .map(function(k){ return startsByColor[k]; })
	            .sort(function(a,b){ return a.start - b.start; });

	          for (var i = 0; i < blocks.length; i++) {
	            blocks[i].end = (i < blocks.length - 1) ? blocks[i+1].start : images.length;
	          }

	          return blocks;
	        };

	        state.getColorBlock = function(colorIdx, colorValue){
	          if (!colorValue) return null;
	          var key = String(colorValue).trim().toLowerCase();
	
	          // Cache per quickview instance (rebuild if image list changes)
	          var _imgs = state.getImages();
	          var _sig = state.getImagesSig(_imgs);
	          if (!state._esBlocks || state._esBlocksColorIdx !== colorIdx || state._esImagesSig !== _sig) {
	            state._esBlocks = state.buildColorBlocks(colorIdx);
	            state._esBlocksColorIdx = colorIdx;
	            state._esImagesSig = _sig;
	          }
	
	          var blocks = state._esBlocks || [];
	          for (var i = 0; i < blocks.length; i++) {
	            if (String(blocks[i].color).trim().toLowerCase() === key) return blocks[i];
	          }
	          return null;
	        };

        state.chooseAlt = function(){
          var images = state.getImages();
          if (!images.length) return '';

          var $main = quickviewTemplate.find('.featured-image img.engoj_img_main_quickview').first();
          var currentSrc = $main.attr('src') || '';
          if (!currentSrc) return '';
          var curIdx = state.findIndex(images, currentSrc);
          if (curIdx < 0) curIdx = 0;

	          // Determine selected color (robust across variant JSON shapes)
	          var colorIdx = state.getColorIndex();
	          var color = (colorIdx >= 0) ? state.getSelectedColorValue() : null;

          // If we can't detect color, fallback to global next image.
          if (!color) {
            if (images.length < 2) return '';
            var nextGlobal = images[(curIdx + 1) % images.length];
            return nextGlobal || '';
          }

	          // Use one "block" per color: [start, end)
	          var block = state.getColorBlock(colorIdx, color);
	          if (!block) {
	            // fallback: global next
	            if (images.length < 2) return '';
	            return images[(curIdx + 1) % images.length] || '';
	          }

	          var groupStart = block.start;
	          var boundary = block.end;
	          var groupLen = boundary - groupStart;
	          if (groupLen < 2) return '';

	          // Constrain current index to the color block range
	          if (curIdx < groupStart || curIdx >= boundary) curIdx = groupStart;

	          var nextIdx = curIdx + 1;
	          if (nextIdx >= boundary) nextIdx = groupStart;
	          var alt = images[nextIdx] || '';

          // If alt resolves to the same as current, skip
          if (state.normalize(alt) === state.normalize(currentSrc)) return '';
          return alt;
        };

        state.setAlt = function(url){
          if (!state.overlay || !state.overlay.length) return;
          if (!url) {
            state.lastAlt = '';
            state.wrap && state.wrap.removeClass('es-pdp-hovering');
            state.overlay.removeAttr('src');
            return;
          }
          if (state.normalize(url) === state.normalize(state.lastAlt)) return;

          state.lastAlt = url;
          state.wrap && state.wrap.removeClass('es-pdp-hovering');
          state.overlay.removeAttr('src');

          var pre = new Image();
          pre.onload = function(){
            try {
              if (!state.overlay || !state.overlay.length) return;
              state.overlay.attr('src', url);
              if (state.wrap && state.wrap.length && state.wrap.is(':hover') && state.shouldEnable()) {
                clearTimeout(state.timer);
                state.timer = setTimeout(function(){
                  if (state.wrap && state.wrap.is(':hover')) state.wrap.addClass('es-pdp-hovering');
                }, state.delay);
              }
            } catch(e) {}
          };
          pre.src = url;
        };

        // Bind hover once per quickview instance
        if (!$wrap.data('esQvHoverBound')) {
          $wrap.data('esQvHoverBound', '1');
          $wrap.on('mouseenter', function(){
  if (!state.shouldEnable()) return;
  if (!state.overlay || !state.overlay.length) return;

  // Make sure "next image" is computed from the CURRENT selected color + current main image
  try { tshopifyQuickview.updateQuickviewHoverSwap(product, quickviewTemplate); } catch(e) {}

  if (!state.overlay.attr('src')) return;

  clearTimeout(state.timer);
  state.timer = setTimeout(function(){
    if (!state.wrap || !state.wrap.length) return;
    if (!state.shouldEnable()) return;
    if (!state.wrap.is(':hover')) return;

    // Show overlay (it may still be loading; it will fade in when ready)
    state.wrap.addClass('es-pdp-hovering');
  }, state.delay);
});
          $wrap.on('mouseleave', function(){
            clearTimeout(state.timer);
            state.timer = null;
            state.wrap && state.wrap.removeClass('es-pdp-hovering');
          });
        }

        quickviewTemplate.data('esQvHoverSwap', state);

        // Initial update
        this.updateQuickviewHoverSwap(product, quickviewTemplate);
      } catch(e) {}
    },

    updateQuickviewHoverSwap: function(product, quickviewTemplate) {
      try {
        if (!product || !quickviewTemplate || !quickviewTemplate.length) return;
        var state = quickviewTemplate.data('esQvHoverSwap');
        if (!state || !state.wrap || !state.overlay) return;
        var alt = state.chooseAlt();
        state.setAlt(alt);
      } catch(e) {}
    },


    // Enable ES-like thumbnail strip in Quickview:
    // - edge fades that hint there's more content
    // - draggable horizontal scrolling (mouse/touch/pointer)
    enableQuickviewThumbDragScroll: function(quickviewTemplate) {
      try {
        if (!quickviewTemplate || !quickviewTemplate.length) return;

        var $wrap = quickviewTemplate.find('.more-views').first();
        var $track = quickviewTemplate.find('.more-views .es-thumb-track').first();
        if (!$track.length) $track = quickviewTemplate.find('.more-views .owl-carousel').first();
        if (!$wrap.length || !$track.length) return;

        // We want a premium, ES-like native scroll strip in Quickview.
        // Owl Carousel thumbs can cause layout drift when swatches are clicked (scrollIntoView + transforms),
        // and click-zones may not navigate reliably in some dynamic quickview renders.
        // So we normalize thumbs to a simple horizontal scroll track.
        $wrap.addClass('es-thumb-fade');
        $wrap.css('overflow', 'visible');
        $wrap.removeClass('owl-carousel-play');

        // Destroy Owl if it was initialized on this thumbnail row, and unwrap back to plain .item nodes.
        try {
          if (window.jQuery && ($track.hasClass('owl-loaded') || $track.data('owl.carousel') || $track.find('.owl-stage-outer').length)) {
            try { $track.trigger('destroy.owl.carousel'); } catch(e0) {}
          }
        } catch(e) {}

        try {
          // Keep existing thumbnail nodes (detach preserves handlers) and strip Owl wrappers if they remain.
          var $items = $track.find('.owl-item .item');
          if ($items.length) {
            $items = $items.detach();
            $track.empty().append($items);
          }
          $wrap.find('.owl-nav, .owl-dots').remove();
          $track.find('.owl-stage-outer, .owl-stage, .owl-item').remove();
          $track.removeClass('owl-carousel owl-loaded owl-drag owl-hidden owl-theme');
          $track.addClass('es-thumb-track');

          // Clear inline styles that Owl may leave behind (width/transform), but keep our CSS-driven layout.
          try {
            var el = $track.get(0);
            if (el && el.style) {
              el.style.transform = '';
              el.style.width = '';
              el.style.left = '';
              el.style.position = '';
            }
          } catch(eX) {}

          // Remove per-item inline widths if any
          $track.find('.item').each(function(){
            try { this.style.width = ''; this.style.marginLeft = ''; this.style.marginRight = ''; } catch(e2) {}
          });
        } catch(e) {}

        // Now resolve the real DOM nodes
        var track = $track.get(0);
        var wrapEl = $wrap.get(0);
        if (!track || !wrapEl) return;

        // Thumbs are normalized to native scroll (not Owl)
        var isOwlThumbs = false;

        // Force native horizontal scrolling behavior on the track
        try {
          track.style.overflowX = 'auto';
          track.style.overflowY = 'hidden';
          track.style.scrollBehavior = 'smooth';
          track.style.webkitOverflowScrolling = 'touch';
        } catch(e) {}
	        // Mark classes so the premium thumbnail rail styles apply reliably
	        try {
	          wrapEl.classList.add('es-thumb-track-wrap');
	          track.classList.add('es-thumb-track');
	        } catch(e) {}

	        // Premium thumbnail navigation: click left/right edges to scroll the thumb strip
	        // This only affects the thumbnail rail (left-side bottom strip) and keeps the main image fixed.
	        try {
	          if (!wrapEl.dataset.esQvThumbZoneBound) {
	            wrapEl.dataset.esQvThumbZoneBound = '1';
	
	            // Ensure positioning context
	            try {
	              var pos = window.getComputedStyle(wrapEl).position;
	              if (!pos || pos === 'static') wrapEl.style.position = 'relative';
	            } catch(e1) {}
	
	            // Keep the same class names as the compiled quickview.js so custom.css applies.
	            var prevBtn = document.createElement('button');
	            prevBtn.type = 'button';
	            prevBtn.className = 'es-qv-thumb-zone es-qv-thumb-zone-prev';
	            prevBtn.setAttribute('aria-label', 'Scroll thumbnails left');
	            prevBtn.innerHTML = '<span class="es-qv-thumb-zone-icon" aria-hidden="true">‹</span>';
	
	            var nextBtn = document.createElement('button');
	            nextBtn.type = 'button';
	            nextBtn.className = 'es-qv-thumb-zone es-qv-thumb-zone-next';
	            nextBtn.setAttribute('aria-label', 'Scroll thumbnails right');
	            nextBtn.innerHTML = '<span class="es-qv-thumb-zone-icon" aria-hidden="true">›</span>';
	
	            wrapEl.appendChild(prevBtn);
	            wrapEl.appendChild(nextBtn);
	
	            var isOwlThumbs = !!($track.hasClass('owl-carousel') || $track.find('.owl-stage').length);
	            var scrollStep = function(dir) {
	              try {
	                // If Owl Carousel manages this row, prefer its API (so it works even when scrollLeft is 0).
	                if (isOwlThumbs && window.jQuery) {
	                  try {
	                    $track.trigger(dir > 0 ? 'next.owl.carousel' : 'prev.owl.carousel');
	                    return;
	                  } catch(e0) {}
	                }
	
	                var step = Math.round((track.clientWidth || 0) * 0.75);
	                if (step < 160) step = 160;
	
	                // Modern browsers
	                if (typeof track.scrollBy === 'function') {
	                  track.scrollBy({ left: dir * step, behavior: 'smooth' });
	                } else {
	                  track.scrollLeft = (track.scrollLeft || 0) + (dir * step);
	                }
	              } catch(e2) {}
	            };
	
	            prevBtn.addEventListener('click', function(e){
	              e.preventDefault();
	              e.stopPropagation();
	              scrollStep(-1);
	            });
	            nextBtn.addEventListener('click', function(e){
	              e.preventDefault();
	              e.stopPropagation();
	              scrollStep(1);
	            });
	
	            var updateZones = function(){
	              try {
	                var max = (track.scrollWidth || 0) - (track.clientWidth || 0);
	                var hasOverflow = max > 4;
	
	                // Hide zones when no overflow (clean look)
	                prevBtn.style.display = hasOverflow ? '' : 'none';
	                nextBtn.style.display = hasOverflow ? '' : 'none';
	                if (!hasOverflow) return;
	
	                // Disable based on position
	                prevBtn.classList.toggle('is-disabled', (track.scrollLeft || 0) <= 2);
	                nextBtn.classList.toggle('is-disabled', (track.scrollLeft || 0) >= (max - 2));
	              } catch(e3) {}
	            };

	            // Initial + keep in sync
	            setTimeout(updateZones, 60);
	            setTimeout(updateZones, 180);
	            try {
	              track.addEventListener('scroll', updateZones, { passive: true });
	            } catch(e4) {}
	            try {
	              window.addEventListener('resize', updateZones);
	            } catch(e5) {}
	          }
	        } catch(e) {}

        // Disable native image drag ghosting (critical for drag-to-scroll)
        try {
          track.querySelectorAll('img').forEach(function(img){
            img.setAttribute('draggable','false');
            img.style.webkitUserDrag = 'none';
            img.style.userDrag = 'none';
          });
        } catch(e) {}
        try {
          // Prevent any dragstart inside thumb strip (anchors/images)
          track.addEventListener('dragstart', function(ev){ ev.preventDefault(); }, true);
          // Prevent image drag initiation on mousedown (some browsers ignore draggable=false)
          track.addEventListener('mousedown', function(ev){
            var t = ev.target;
            if (t && t.tagName === 'IMG') ev.preventDefault();
          }, true);
        } catch(e) {}

        // Helper: set main image with a subtle fade (preview-safe)
        var _esSetMain = function(src, isPreview){
          try {
            if (!src) return;
            var $img = quickviewTemplate.find('.featured-image img').first();
            if (!$img.length) return;
            var current = $img.attr('src');
            if (current === src) return;

            var $loading = quickviewTemplate.find('.featured-image .loading').first();
            $img.addClass('es-qv-fading');
            if ($loading.length) $loading.show();

            // Ensure fade-in happens after load
            $img.off('load.esQvFade').on('load.esQvFade', function(){
              try { $img.removeClass('es-qv-fading'); } catch(e2) {}
              try { if ($loading.length) $loading.hide(); } catch(e3) {}
            });

            $img.attr('src', src);

            // Mark previewing state (optional)
            quickviewTemplate.toggleClass('es-qv-previewing', !!isPreview);
          } catch(e) {}
        };

        // Thumbnail hover preview (ES-like): hover = preview, click = select
        try {
          // Bind once per quickview instance
          if (!quickviewTemplate.data('esQvThumbHoverBound')) {
            quickviewTemplate.data('esQvThumbHoverBound', true);

            // Hover on a thumb previews that image
            quickviewTemplate.on('mouseenter.esQvThumbPreview', '.more-views .es-thumb-track a[data-image]', function(){
              try {
                // Don't preview while user is dragging the strip
                var $t = quickviewTemplate.find('.more-views .es-thumb-track').first();
                if ($t.hasClass('is-dragging')) return;

                var $item = $(this).closest('.item');
                quickviewTemplate.find('.more-views .es-thumb-track .item').removeClass('is-preview');
                $item.addClass('is-preview');

                var src = $(this).attr('data-image');
                _esSetMain(src, true);
              } catch(e) {}
            });

            // Leaving the strip restores the truly selected/active thumb image
            quickviewTemplate.on('mouseleave.esQvThumbPreview', '.more-views', function(){
              try {
                quickviewTemplate.find('.more-views .es-thumb-track .item').removeClass('is-preview');
                var $active = quickviewTemplate.find('.more-views .es-thumb-track .item.is-active a[data-image]').first();
                if ($active.length) _esSetMain($active.attr('data-image'), false);
                else quickviewTemplate.removeClass('es-qv-previewing');
              } catch(e) {}
            });
          }
        } catch(e) {}

        // Wheel = horizontal scroll (very ES-like on desktop)
        try {
          if (!track.dataset.esWheelBound) {
            track.dataset.esWheelBound = '1';
            track.addEventListener('wheel', function(ev){
              try {
                // Shift vertical wheel into horizontal scroll when horizontal overflow exists
                var max = (track.scrollWidth || 0) - (track.clientWidth || 0);
                if (max <= 2) return;

                var dy = ev.deltaY || 0;
                var dx = ev.deltaX || 0;
                // Prefer dy since many mice produce dy only
                if (Math.abs(dy) >= Math.abs(dx)) {
                  track.scrollLeft += dy;
                  ev.preventDefault();
                  tshopifyQuickview._updateQuickviewThumbFade(wrapEl, track);
                }
              } catch(e2) {}
            }, { passive: false });
          }
        } catch(e) {}

        // Bind once per DOM node
        if (track.dataset && track.dataset.esThumbDragBound === '1') {
          this._updateQuickviewThumbFade(wrapEl, track);
          return;
        }
        if (track.dataset) track.dataset.esThumbDragBound = '1';

        var isDown = false;
        var moved = false;
        var startX = 0;
        var startScroll = 0;
        var moved = 0;
        var pointerId = null;
        var clickBlockUntil = 0;

        var onPointerDown = function(e) {
          // Only left-click for mouse; allow touch/pen
          if (e.pointerType === 'mouse' && e.button !== 0) return;

          isDown = true;
          moved = 0;
          pointerId = e.pointerId;
          startX = e.clientX;
          startScroll = track.scrollLeft;

          try { track.setPointerCapture && track.setPointerCapture(pointerId); } catch(err) {}
          track.classList.add('is-dragging');
        };

        var onPointerMove = function(e) {
          if (!isDown) return;
          if (pointerId !== null && e.pointerId !== pointerId) return;

          var dx = e.clientX - startX;
          moved = Math.max(moved, Math.abs(dx));
          track.scrollLeft = startScroll - dx;

          tshopifyQuickview._updateQuickviewThumbFade(wrapEl, track);

          // Prevent text selection / page scrolling while dragging with mouse
          if (e.pointerType === 'mouse') {
            try { e.preventDefault(); } catch(err) {}
          }
        };

        var endDrag = function(e) {
          if (!isDown) return;
          isDown = false;

          track.classList.remove('is-dragging');
          try { track.releasePointerCapture && pointerId !== null && track.releasePointerCapture(pointerId); } catch(err) {}
          pointerId = null;

          // If user dragged, suppress the next click on a thumbnail (otherwise it "clicks" while dragging)
          if (moved > 6) {
            clickBlockUntil = Date.now() + 260;
          }

          tshopifyQuickview._updateQuickviewThumbFade(wrapEl, track);
        };

        track.addEventListener('pointerdown', onPointerDown, { passive: true });
        track.addEventListener('pointermove', onPointerMove, { passive: false });
        track.addEventListener('pointerup', endDrag, { passive: true });
        track.addEventListener('pointercancel', endDrag, { passive: true });
        track.addEventListener('lostpointercapture', endDrag, { passive: true });
        // Prevent native image dragging (ghost image) so dragging feels like scrolling.
        try {
          track.addEventListener('dragstart', function(ev){ try{ ev.preventDefault(); }catch(err){} }, true);
          // Suppress accidental clicks when the user is dragging to scroll
          try {
            track.addEventListener('click', function(ev){
              try {
                if (track.dataset && track.dataset.esDragMoved === '1') {
                  ev.preventDefault();
                  ev.stopPropagation();
                }
              } catch(e) {}
            }, true);
          } catch(e) {}
        } catch(e) {}


        // Allow wheel scrolling (trackpad) to update fades
        track.addEventListener('scroll', function() {
          tshopifyQuickview._updateQuickviewThumbFade(wrapEl, track);
        }, { passive: true });

        // Block click after drag (delegated, works even if thumbs get re-rendered)
        $track.on('click', 'a', function(ev) {
          if (Date.now() < clickBlockUntil) {
            ev.preventDefault();
            ev.stopImmediatePropagation();
            return false;
          }
        });

        // Initial state
        this._updateQuickviewThumbFade(wrapEl, track);

        // Update on resize
        try {
          var resizeTimer = null;
          $(window).on('resize.esThumbFade', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              tshopifyQuickview._updateQuickviewThumbFade(wrapEl, track);
            }, 120);
          });
        } catch(e2) {}
      } catch(e) {}
    },

    _updateQuickviewThumbFade: function(wrapEl, trackEl) {
      try {
        if (!wrapEl || !trackEl) return;
        var max = (trackEl.scrollWidth || 0) - (trackEl.clientWidth || 0);
        if (max <= 2) {
          wrapEl.classList.remove('es-fade-left');
          wrapEl.classList.remove('es-fade-right');
          return;
        }
        var left = (trackEl.scrollLeft || 0) > 2;
        var right = (trackEl.scrollLeft || 0) < (max - 2);
        wrapEl.classList.toggle('es-fade-left', !!left);
        wrapEl.classList.toggle('es-fade-right', !!right);
      } catch(e) {}
    },


    // Mark the active thumbnail that matches the current main image
    setQuickviewActiveThumb: function(quickviewTemplate, mainSrc, shouldScroll) {
      try {
        if (!quickviewTemplate || !quickviewTemplate.length) return;
        var $track = quickviewTemplate.find('.more-views .es-thumb-track').first();
        if (!$track.length) $track = quickviewTemplate.find('.more-views .owl-carousel').first();
        if (!$track.length) return;

        var state = null;
        try { state = quickviewTemplate.data('esQvHoverSwap'); } catch(e) {}
        var norm = function(url){
          if (!url) return '';
          url = String(url).replace(/^https?:/,'').split('?')[0];
          if (state && state.normalize) return state.normalize(url);
          return url;
        };
        var target = norm(mainSrc || quickviewTemplate.find('.featured-image img').attr('src'));
        if (!target) return;
        var targetFile = target.split('/').pop();

        var $best = $track.find('a[data-image]').filter(function(){
          var u = this.getAttribute('data-image');
          if (!u) return false;
          var nu = norm(u);
          if (!nu) return false;
          if (nu === target) return true;
          var f = nu.split('/').pop();
          return (f && targetFile && f === targetFile);
        }).first();

        $track.find('.item').removeClass('is-active');
        if ($best.length) {
          var $item = $best.closest('.item');
          $item.addClass('is-active');
          try { tshopifyQuickview._flashQuickviewThumb($item); } catch(e2) {}
          if (shouldScroll) {
            try { tshopifyQuickview._scrollThumbIntoView($item); } catch(e3) {}
          }
        }
      } catch(e) {}
    },

    _flashQuickviewThumb: function($item){
      try {
        if (!$item || !$item.length) return;
        $item.addClass('es-flash');
        setTimeout(function(){ try{ $item.removeClass('es-flash'); }catch(e){} }, 260);
      } catch(e) {}
    },

    _scrollThumbIntoView: function($item){
      try {
        if (!$item || !$item.length) return;
        var el = $item.get(0);
        if (!el) return;
        // IMPORTANT: avoid element.scrollIntoView() inside Quickview.
        // In some layouts it can scroll the entire modal container horizontally,
        // which makes the left hero image appear to "drift" when selecting swatches.
        // Instead, scroll only the thumbnails track.
        var $track = $item.closest('.es-thumb-track');
        if (!$track.length) $track = $item.closest('.owl-carousel');
        var track = $track.get(0);
        if (track && track.scrollTo) {
          var left = (el.offsetLeft || 0) - (track.clientWidth - el.clientWidth) / 2;
          if (left < 0) left = 0;
          try { track.scrollTo({ left: left, behavior: 'smooth' }); } catch(e2) { track.scrollLeft = left; }
        }
      } catch(e) {}
    },

    // Keyboard navigation for thumbnails when Quickview is open
    bindQuickviewThumbKeyboardNav: function(){
      try {
        if (document.documentElement && document.documentElement.dataset && document.documentElement.dataset.esQvThumbKeys === '1') return;
        if (document.documentElement && document.documentElement.dataset) document.documentElement.dataset.esQvThumbKeys = '1';
        $(document).on('keydown.esQvThumbKeys', function(ev){
          try {
            if (!$('.quickview-product').hasClass('active')) return;
            var key = ev.key || ev.keyCode;
            var isLeft = (key === 'ArrowLeft' || key === 37);
            var isRight = (key === 'ArrowRight' || key === 39);
            var isHome = (key === 'Home' || key === 36);
            var isEnd = (key === 'End' || key === 35);
            if (!isLeft && !isRight && !isHome && !isEnd) return;

            var $qv = $('.quickview-product');
            var $track = $qv.find('.more-views .es-thumb-track').first();
            if (!$track.length) $track = $qv.find('.more-views .owl-carousel').first();
            if (!$track.length) return;

            var $items = $track.find('.item');
            if (!$items.length) return;

            var $active = $items.filter('.is-active').first();
            if (!$active.length) $active = $items.first();

            var $next = $active;
            if (isHome) $next = $items.first();
            else if (isEnd) $next = $items.last();
            else if (isLeft) $next = $active.prev('.item');
            else if (isRight) $next = $active.next('.item');

            if (!$next.length) $next = $active;
            var $a = $next.find('a[data-image]').first();
            if ($a.length) {
              ev.preventDefault();
              $a.trigger('click');
              tshopifyQuickview.setQuickviewActiveThumb($qv, $a.attr('data-image'), true);
            }
          } catch(e2) {}
        });
      } catch(e) {}
    },


    // After selecting a color in Quickview, auto-scroll the thumbnail strip
    // so the selected color's image group starts first (better browsing).
    syncQuickviewThumbsToSelectedColor: function(product, quickviewTemplate) {
      try {
        if (!product || !quickviewTemplate || !quickviewTemplate.length) return;
        var state = quickviewTemplate.data('esQvHoverSwap');
        if (!state || typeof state.getColorIndex !== 'function') return;

        var colorIdx = state.getColorIndex();
        if (colorIdx < 0) return;
        var color = state.getSelectedColorValue();
        if (!color) return;

        var images = state.getImages();
        if (!images || images.length < 2) return;

        // Ensure blocks are up-to-date for the current image list
        var sig = state.getImagesSig(images);
        if (!state._esBlocks || state._esBlocksColorIdx !== colorIdx || state._esImagesSig !== sig) {
          state._esBlocks = state.buildColorBlocks(colorIdx);
          state._esBlocksColorIdx = colorIdx;
          state._esImagesSig = sig;
        }

        var block = state.getColorBlock(colorIdx, color);
        if (!block || typeof block.start !== 'number') return;

        var $carousel = quickviewTemplate.find('.more-views .es-thumb-track').first();
        if (!$carousel.length) $carousel = quickviewTemplate.find('.more-views .owl-carousel').first();
        if (!$carousel.length) return;

        var idx = Math.max(0, block.start);

        if ($carousel.hasClass('slick-initialized')) {
          $carousel.slick('slickGoTo', idx, true);
          return;
        }

        // Native scroll (ES-style draggable strip)
        var track = $carousel.get(0);
        var wrapEl = quickviewTemplate.find('.more-views').first().get(0);
        var $items = $carousel.find('.item');
        if (!$items.length) $items = $carousel.children();
        var target = $items.get(idx);
        if (target) {
          // IMPORTANT: avoid scrollIntoView() because it can shift the modal.
          try {
            if (track && track.scrollTo) {
              var left = (target.offsetLeft || 0) - (track.clientWidth - target.clientWidth) / 2;
              if (left < 0) left = 0;
              track.scrollTo({ left: left, behavior: 'smooth' });
            } else if (track) {
              track.scrollLeft = (target.offsetLeft || 0) - (track.offsetLeft || 0);
            }
          } catch(err2) {}
        }
        try { tshopifyQuickview._updateQuickviewThumbFade(wrapEl, track); } catch(e) {}
      } catch(e) {}
    },

    selectCallbackQuickview: function(variant, selector,quickviewTemplate) {
      // Shopify.OptionSelectors may pass `null` when no variant matches the current option combination.
      // In that case we should NOT throw (which would break swatch clicking in Quickview).
      if (variant && variant.id) {
        /*Swym Matt*/ (function(){
        try {
          var $btns = $('.quickview-product button.es-wishlist-btn');
          $btns.attr('data-variant-id', variant.id);
          $btns.each(function(){ try{ this.dataset.variantId = variant.id; }catch(e){} });
        } catch(e) {}
        try {
          if (window.esWishlistApplyToButton) {
            var b = document.querySelector('.quickview-product button.es-wishlist-btn');
            if (b) window.esWishlistApplyToButton(b);
          }
        } catch(e) {}
      })();
      }
      /*Swym Matt*/ document.dispatchEvent(new CustomEvent("swym:qv-loaded"));
      var self = this;
      var productItem = jQuery('.quickview-product .product-item'),
          addToCart = productItem.find('.btn-addToCart'),
          productPrice = productItem.find('.price'),
          comparePrice = productItem.find('.compare-price'),
          totalPrice = productItem.find('.total-price span');

      if (variant && variant.featured_image) {
        var originalImage = jQuery(".engoj_img_main_quickview");
        var newImage = variant.featured_image;
        var element = originalImage[0];
        Shopify.Image.switchImage(newImage, element, function (newImageSizedSrc, newImage, element) {
          var $el = $(element);
          $el.attr('src', newImageSizedSrc);
          // Update hover swap alt image after main image changes
          try {
            var $qv = jQuery('.quickview-product');
            var p = $qv.data('esQvProduct');
            tshopifyQuickview.updateQuickviewHoverSwap(p, $qv);
          } catch(e) {}
          try {
            // Also scroll thumbnails so the selected color group starts first
            setTimeout(function(){ tshopifyQuickview.syncQuickviewThumbsToSelectedColor(p, $qv); }, 60);
          } catch(e2) {}
          // document.dispatchEvent(new CustomEvent("swym:variant-change"));
      });
      }

      if (variant) {
        var __txtAdd = addToCart.data('esAddToCart') || addToCart.attr('data-es-add-to-cart') || 'Add to Cart';
        var __txtOOS = addToCart.data('esOutOfStock') || addToCart.attr('data-es-out-of-stock') || 'Out Of Stock';

        if (variant.available) {
          addToCart.removeClass('disabled').removeAttr('disabled').text(__txtAdd);
                                                                        } else {
                                                                        
                                                                        addToCart.val('sold_out').addClass('disabled').attr('disabled', 'disabled').text(__txtOOS);
        }
        productPrice.html(Shopify.formatMoney(currencyConverter(variant.price), window.money_format));



          if ( variant.compare_at_price > variant.price ) {
            comparePrice.html(Shopify.formatMoney(currencyConverter(variant.compare_at_price), window.money_format)).show();
            productPrice.addClass('on-sale');
          } else {
            comparePrice.hide();
            productPrice.removeClass('on-sale');
          }

          var form = jQuery('#' + selector.domIdPrefix).closest('form');
          for (var i=0,length=variant.options.length; i<length; i++) {
            var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
            if (radioButton.length) {
              radioButton.get(0).checked = true;
            }
          }


          var inventoryInfo = productItem.find('.product-inventory span');
          if (variant.available) {
            if (variant.inventory_management!=null) {
              inventoryInfo.text(variant.inventory_quantity + " " + 'in_stock');
            } else {
              inventoryInfo.text('many_in_stock');
            }
          } else {
            inventoryInfo.text('out_of_stock');
          }

          // Total:
          var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
          var unitPriceTextMatch = $('.quickview-product .price').text().match(regex);

          if (!unitPriceTextMatch) {
            regex = /([0-9]+[.|,][0-9]+)/g;
            unitPriceTextMatch = $('.quickview-product .price').text().match(regex);
          }

          if (unitPriceTextMatch) {
            var unitPriceText = unitPriceTextMatch[0];
            var unitPrice = unitPriceText.replace(/[.|,]/g, '');
            var quantity = parseInt($('.quickview-product input[name=quantity]').val());
            var totalPrice = unitPrice * quantity;
            totalPrice = currencyConverter(totalPrice);

            var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
            regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
            if (!totalPriceText.match(regex)) {
              regex = /([0-9]+[.|,][0-9]+)/g;
            }
            var totalPriceTextMatch = totalPriceText.match(regex);
            totalPriceText = totalPriceTextMatch ? totalPriceTextMatch[0] : totalPriceText.replace(/[^0-9.,]/g, '');

            var regInput = new RegExp(unitPriceText, "g");
            var totalPriceHtml = $('.quickview-product .price').html().replace(regInput, totalPriceText);

            $('.quickview-product .total-price span').html(totalPriceHtml);
          }

          if (variant && variant.featured_image) {
            var newImage = Shopify.resizeImage(variant.featured_image.src, 'small');
            newImage = newImage.replace(/https?:/,'');
            jQuery('.quick-view .quickview-more-views img').each(function() {
              var grandSize = jQuery(this).attr('src');
              if (grandSize == newImage) {
                jQuery(this).parent().trigger('click');
                return false;
              }
            });
          }

      } else {
          // No matching variant for current option combination
          var __txtUn = addToCart.data('esUnavailable') || addToCart.attr('data-es-unavailable') || addToCart.data('esOutOfStock') || addToCart.attr('data-es-out-of-stock') || 'Out Of Stock';
          addToCart.text(__txtUn).addClass('disabled').attr('disabled', 'disabled');
        }


        // Keep hover-swap (2nd image) in sync even if the main image didn't change.
        try {
          var $qv2 = jQuery('.quickview-product');
          var p2 = $qv2.data('esQvProduct');
          tshopifyQuickview.updateQuickviewHoverSwap(p2, $qv2);
        } catch(e) {}

      },
        /* Quick View SWATCH */
        createQuickViewVariantsSwatch: function(product, quickviewTemplate) {
          var self = this;
          if (product.variants.length > 1) {
            // Populate the hidden variant select (required by Shopify.OptionSelectors)
            for (var i = 0; i < product.variants.length; i++) {
              var variant = product.variants[i];
              var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
              quickviewTemplate.find('form.variants > select').append(option);
            }

            // Pick a sane default variant for initial state (prefer first available).
            var __defaultVariant = null;
            for (var __k = 0; __k < product.variants.length; __k++) {
              if (product.variants[__k].available) { __defaultVariant = product.variants[__k]; break; }
            }
            if (!__defaultVariant) __defaultVariant = product.variants[0];

            // Ensure the hidden select defaults to the chosen variant (so the price/image/buttons are correct).
            var $variantSelect = quickviewTemplate.find('form.variants > select');
            if ($variantSelect.length) {
              $variantSelect.val(__defaultVariant.id);
            }

            new Shopify.OptionSelectors("product-select-" + product.id, {
              product: product,
              onVariantSelected: self.selectCallbackQuickview,
              enableHistoryState: true
            });

            var options = "";

            for (var i = 0; i < product.options.length; i++) {
              var optName = (product.options[i] && product.options[i].name) ? product.options[i].name : product.options[i];
              var is_color = /Color|Colour/i.test(optName);

              if (is_color) {
                // Match PDP swatch style: overline + thumbnail + label
                options += '<div class="maxus-productdetail__options">';
                options += '<div class="swatch swatch_radio1 clearfix" data-option-index="' + i + '">';
                options += '<div class="es-swatch-strip">';
              } else {
                // Fallback for non-color options
                options += '<div class="swatch clearfix" data-option-index="' + i + '">';
                options += '<div class="header">' + optName + '</div>';
              }

              var optionValues = [];
              var __defaultValueForThisOption = (__defaultVariant && __defaultVariant.options) ? __defaultVariant.options[i] : null;
              for (var j = 0; j < product.variants.length; j++) {
                var variant = product.variants[j];
                var value = variant.options[i];
                var valueHandle = convertToSlug(value);
                var forText = 'swatch-' + i + '_' + valueHandle;

                if (optionValues.indexOf(value) < 0) {
                  var dataValue = (value + '').replace(/"/g, '&quot;');
                  // IMPORTANT: Sold-out swatches must remain clickable in Quickview (so users can preview),
                  // therefore we NEVER disable the radio input.
                  var disabledAttr = '';
                  // Mark checked based on the default variant rather than the first item in the loop.
                  var checkedAttr = (__defaultValueForThisOption !== null && value === __defaultValueForThisOption) ? ' checked' : '';

                  // Determine availability for this swatch value (at this option index) across ALL variants.
                  // This prevents the swatch being incorrectly marked soldout just because the first matching
                  // variant in the JSON happens to be unavailable.
                  var valueHasAvailable = false;
                  for (var __m = 0; __m < product.variants.length; __m++) {
                    var __v = product.variants[__m];
                    if (__v.options && __v.options[i] === value && __v.available) { valueHasAvailable = true; break; }
                  }
                  var availabilityClass = valueHasAvailable ? ' available ' : ' soldout ';
                  var ariaDisabled = valueHasAvailable ? '' : ' aria-disabled="true"';

                  if (is_color) {
                    // Use the first variant image as the color thumbnail (same behavior as PDP swatches)
                    var thumbSrc = '';
                    if (variant.featured_image && variant.featured_image.src) {
                      thumbSrc = variant.featured_image.src;
                    } else if (variant.image && variant.image.src) {
                      thumbSrc = variant.image.src;
                    } else if (product.featured_image && product.featured_image.src) {
                      thumbSrc = product.featured_image.src;
                    }

                    options += '<div data-value="' + dataValue + '" data-style="square" class="maxus-color none color ' + valueHandle + availabilityClass + '">';
                    options += '<input id="' + forText + '" type="radio" name="option-' + i + '" value="' + dataValue + '"' + checkedAttr + disabledAttr + ariaDisabled + ' />';
                    options += '<div class="radio_style2">';
                    options += '<label class="color_style2" for="' + forText + '"' + (thumbSrc ? ' style="background-image:url(' + thumbSrc + ');"' : '') + '></label>';
                    options += '<span class="text_color">' + value + '</span>';
                    options += '</div>';
                    options += '</div>';
                  } else {
                    options += '<div data-value="' + dataValue + '" class="swatch_rectangle1 ' + valueHandle + availabilityClass + '">';
                    options += '<input id="' + forText + '" type="radio" name="option-' + i + '" value="' + dataValue + '"' + checkedAttr + disabledAttr + ariaDisabled + ' />';
                    options += '<label class="rectangle_style1" for="' + forText + '"><span class="text_rec">' + valueHandle.replace('-', ' ') + '</span></label>';
                    options += '</div>';
                  }

                  optionValues.push(value);
                }
              }

              if (is_color) {
                options += '</div></div></div>';
              } else {
                options += '</div>';
              }
            }

            quickviewTemplate.find('form.variants > select').after(options);
            quickviewTemplate.find('.swatch :radio').change(function() {
              var optionIndex = $(this).closest('.swatch').attr('data-option-index');
              var optionValue = $(this).val();
              $(this)
                .closest('form')
                .find('.single-option-selector')
                .eq(optionIndex)
                .val(optionValue)
                .trigger('change');
            });

            // NOTE: Do NOT call Shopify.linkOptionSelectors() in Quickview.
            // That helper filters option values based on availability and can break the "soldout swatch is selectable"
            // behavior you want. Shopify.OptionSelectors + our swatch->selector sync is enough.

            // Force initial sync: trigger a change so the UI reflects the default variant immediately.
            try {
              var $form = quickviewTemplate.find('form.variants');
              for (var __oi = 0; __oi < product.options.length; __oi++) {
                var __val = (__defaultVariant && __defaultVariant.options) ? __defaultVariant.options[__oi] : null;
                if (__val !== null) {
                  $form.find('.single-option-selector').eq(__oi).val(__val);
                }
              }
              $form.find('.single-option-selector').first().trigger('change');
            } catch (e) {}

          } else {
            // Single-variant product: keep add-to-cart functional, but still render a selected swatch
            // (for visual consistency with multi-variant products).
            quickviewTemplate.find('form.variants > select').remove();

            var $formSingle = quickviewTemplate.find('form.variants');
            var $actionsSingle = $formSingle.find('.product-actions');
            var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';

            // Keep hidden id input ABOVE the add-to-cart area so layout stays consistent.
            if ($actionsSingle.length) {
              $actionsSingle.before(variant_field);
            } else {
              $formSingle.append(variant_field);
            }

            // Render a single color swatch (if Color/Colour option exists)
            try {
              var singleOptions = '';
              for (var i2 = 0; i2 < product.options.length; i2++) {
                var optName2 = (product.options[i2] && product.options[i2].name) ? product.options[i2].name : product.options[i2];
                var is_color2 = /Color|Colour/i.test(optName2);
                if (!is_color2) continue;

                var v0 = product.variants[0];
                var value2 = (v0 && v0.options) ? v0.options[i2] : null;
                if (!value2) continue;

                var valueHandle2 = convertToSlug(value2);
                var forText2 = 'swatch-' + i2 + '_' + valueHandle2;
                var dataValue2 = (value2 + '').replace(/"/g, '&quot;');

                // Best thumbnail fallback chain
                var thumbSrc2 = '';
                if (v0.featured_image && v0.featured_image.src) {
                  thumbSrc2 = v0.featured_image.src;
                } else if (v0.image && v0.image.src) {
                  thumbSrc2 = v0.image.src;
                } else if (product.featured_image && product.featured_image.src) {
                  thumbSrc2 = product.featured_image.src;
                }

                singleOptions += '<div class="maxus-productdetail__options">';
                singleOptions += '<div class="swatch swatch_radio1 clearfix" data-option-index="' + i2 + '">';
                singleOptions += '<div class="es-swatch-strip">';
	                // NOTE: keep the closing ">" inside the string; otherwise it breaks JS parsing.
	                singleOptions += '<div data-value="' + dataValue2 + '" data-style="square" class="maxus-color none color ' + valueHandle2 + ' available">';
                singleOptions += '<input id="' + forText2 + '" type="radio" name="option-' + i2 + '" value="' + dataValue2 + '" checked />';
                singleOptions += '<div class="radio_style2">';
                singleOptions += '<label class="color_style2" for="' + forText2 + '"' + (thumbSrc2 ? ' style="background-image:url(' + thumbSrc2 + ');"' : '') + '></label>';
                singleOptions += '<span class="text_color">' + value2 + '</span>';
                singleOptions += '</div></div></div></div></div>';
              }

              if (singleOptions) {
                if ($actionsSingle.length) {
                  $actionsSingle.before(singleOptions);
                } else {
                  $formSingle.append(singleOptions);
                }
              }
            } catch (eSingle) {}
          }
        },

        /* Quick View */
          createQuickViewVariants: function(product, quickviewTemplate) {
            var self = this;
            if (product.variants.length > 1) {
              for (var i = 0; i < product.variants.length; i++) {
                var variant = product.variants[i];
                var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
                quickviewTemplate.find('form.variants > select').append(option);
              }

              new Shopify.OptionSelectors("product-select-" + product.id, {
                product: product,
                onVariantSelected: self.selectCallbackQuickview,
                enableHistoryState: true
              });

              //$('.quickview-product .single-option-selector').selectize();
              // $('.quickview-product .selectize-input input').attr("disabled", "disabled");

              if (product.options.length == 1) {
                $('.selector-wrapper:eq(0)').prepend('<label>' + product.options[0].name + '</label>');
              }

              quickviewTemplate.find('form.variants .selector-wrapper label').each(function(i, v) {
                $(this).html(product.options[i].name);
              });

            } else {
              quickviewTemplate.find('form.variants > select').remove();
              var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
              quickviewTemplate.find('form.variants').append(variant_field);
            }

          },

            /* Quick View VIEWMORE Slider */
            quickViewSlider: function(product, quickviewTemplate) {
              var featuredImage = Shopify.resizeImage(product.featured_image, 'grande');
      // Note: some browsers may display native hover tooltips from image alt text.
      // Quickview is a secondary context, so keep alt empty here to avoid showing product-title tooltips.
      quickviewTemplate.find('.featured-image').append('<a class="product-photo" href="' + product.url + '" aria-label="View product"><img class="engoj_img_main_quickview" draggable="false" src="' + featuredImage + '" alt=""/><span class="loading" style="height: 100%; width: 100%; top:0; left:0 z-index: 999; position: absolute; display: none; background: url(' + window.loading_url + ') center no-repeat;"></span></a>');

      // Init ES-like hover swap on the main quickview image
      try { tshopifyQuickview.initQuickviewHoverSwap(product, quickviewTemplate); } catch(e) {}

      /* ES FIX (2026-01-29): keep QuickView wishlist button functional (variant-first, no Swym auto-init) */
      try {
        var $swymBtn = $('.quickview-product button.es-wishlist-btn');
        if ($swymBtn && $swymBtn.length) {
          // Always overwrite the URL/id for the product being viewed.
          // NOTE: do NOT append to an existing URL (it can create an invalid URL and break add-to-wishlist).
          var origin = (window.location && window.location.origin) ? window.location.origin : '';
          $swymBtn.attr('data-product-url', origin + product.url);
          $swymBtn.attr('data-product-id', product.id);

          // Ensure variant id is valid even for single-variant products (no OptionSelectors callback).
          var vid = null;
          try {
            vid = $('.quickview-product').find('input[name="id"]').val() || $('.quickview-product').find('select[name="id"]').val();
          } catch(eVid) {}
          if (!vid && product.variants && product.variants.length) vid = product.variants[0].id;
          if (vid) $swymBtn.attr('data-variant-id', vid);

          // Re-apply visual state for the current variant.
          try { if (window.esWishlistApplyToButton) window.esWishlistApplyToButton($swymBtn.get(0)); } catch(eInit) {}
        }
      } catch(eSwym) {}

      // Notify any Swym/ES listeners after the QuickView DOM is ready.
      try { document.dispatchEvent(new CustomEvent("swym:qv-loaded")); } catch(eEvt) {}
              if (product.images.length != 0) {
                var quickViewCarousel = quickviewTemplate.find('.more-views .owl-carousel');

                for (i in product.images) {
                  var grande = Shopify.resizeImage(product.images[i], 'grande');
                  var compact = Shopify.resizeImage(product.images[i], 'compact');
                  var item = '<div class="item"><a href="javascript:void(0)" data-image="' + grande + '"><img src="' + compact + '" draggable="false" /></a></div>';
                  quickViewCarousel.append(item);
                }

                quickViewCarousel.find('a').click(function() {
                  try { tshopifyQuickview.setQuickviewActiveThumb(quickviewTemplate, $(this).attr('data-image'), false); } catch(eAct) {}
                  var featureImage = quickviewTemplate.find('.featured-image img');
                  var moreviewLoad = quickviewTemplate.find('.featured-image .loading');
                  if (featureImage.attr('src') != $(this).attr('data-image')) {
                    featureImage.attr('src', $(this).attr('data-image'));
                    try { tshopifyQuickview.setQuickviewActiveThumb(quickviewTemplate, $(this).attr('data-image'), false); } catch(eAct3) {}
                    moreviewLoad.show();
                    featureImage.on('load', function(e){
                      moreviewLoad.hide();
                      $(this).unbind('load');
                      moreviewLoad.hide();
                      // Update hover swap alt after thumbnail load
                      try { tshopifyQuickview.updateQuickviewHoverSwap(product, quickviewTemplate); } catch(err) {}
                    });
                    // Update immediately as well (in case cached)
                    try { tshopifyQuickview.updateQuickviewHoverSwap(product, quickviewTemplate); } catch(err2) {}
                  }
                });
                
                setTimeout(function(){
                  try {
                    var $carousel = quickviewTemplate.find('.more-views .es-thumb-track').first();
        if (!$carousel.length) $carousel = quickviewTemplate.find('.more-views .owl-carousel').first();
                    if (!$carousel.length) $carousel = $('.quickview-product .more-views .owl-carousel').first();

                    // Make the thumb strip ES-like: native horizontal scroll + drag + edge fades.
                    try { tshopifyQuickview.enableQuickviewThumbDragScroll(quickviewTemplate); } catch(e0) {}

                    // Keep hover-swap mapping fresh once thumbnails are ready.
                    try { tshopifyQuickview.updateQuickviewHoverSwap(product, quickviewTemplate); } catch(e) {}
                    try { tshopifyQuickview.syncQuickviewThumbsToSelectedColor(product, quickviewTemplate); } catch(e2) {}
                  } catch(err) {}
                }, 80);

              } else {
                quickviewTemplate.find('.more-views').remove();
              }

            },

              /* Quick View ADD TO CART */
              initQuickviewAddToCart: function() {
                if ($('.quickview-product .btn-addToCart').length > 0) {
                  $('.quickview-product .btn-addToCart').click(function() {
                    var variant_id = $('.quickview-product select[name=id]').val();
                    if (!variant_id) {
                      variant_id = $('.quickview-product input[name=id]').val();
                    }
                    var quantity = $('.quickview-product input[name=quantity]').val();
                    if (!quantity) {
                      quantity = 1;
                    }

                    var title = $('.quickview-product .product-title a').html();
                    var image = $('.quickview-product .featured-image img').attr('src');

                    doAjaxAddToCart(variant_id, quantity, title, image);

                  });
                }
              },
                /* Quick View update Pricing */
                updatePricingQuickview: function() {
                  var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
                  var unitPriceTextMatch = $('.quickview-product .price').text().match(regex);

                  if (!unitPriceTextMatch) {
                    regex = /([0-9]+[.|,][0-9]+)/g;
                    unitPriceTextMatch = $('.quickview-product .price').text().match(regex);
                  }

                  if (unitPriceTextMatch) {
                    var unitPriceText = unitPriceTextMatch[0];
                    var unitPrice = unitPriceText.replace(/[.|,]/g, '');
                    var quantity = parseInt($('.quickview-product input[name=quantity]').val());
                    var totalPrice = unitPrice * quantity;

                    var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
                    regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
                    if (!totalPriceText.match(regex)) {
                      regex = /([0-9]+[.|,][0-9]+)/g;
                    }
                    var totalPriceTextMatch = totalPriceText.match(regex);
            totalPriceText = totalPriceTextMatch ? totalPriceTextMatch[0] : totalPriceText.replace(/[^0-9.,]/g, '');

                    var regInput = new RegExp(unitPriceText, "g");
                    var totalPriceHtml = $('.quickview-product .price').html().replace(regInput, totalPriceText);

                    $('.quickview-product .total-price span').html(totalPriceHtml);
                  }
                }

    }
  })(jQuery);

// Global helper: strip title tooltips within quickview image region (Safari/iOS shows black tooltip)
// Safe to call multiple times.
(function(){
  function stripTitles(root){
    if (!root) return;
    try {
      var scope = root.querySelector ? root : document.querySelector(root);
      if (!scope) return;

      var removeTitles = function(){
        // Only strip within the image/slider region to avoid breaking intentional tooltips
        var els = scope.querySelectorAll('.product-image [title], .product-image [data-original-title]');
        for (var i = 0; i < els.length; i++) {
          els[i].removeAttribute('title');
          els[i].removeAttribute('data-original-title');
        }
      };

      removeTitles();

      // Keep it clean even if sliders/zoom scripts add title later
      if (!scope.__es_title_observer && window.MutationObserver) {
        scope.__es_title_observer = new MutationObserver(function(mutations){
          for (var m = 0; m < mutations.length; m++) {
            if (mutations[m].type === 'attributes' && mutations[m].attributeName === 'title') {
              var t = mutations[m].target;
              if (t && t.closest && t.closest('.product-image')) {
                t.removeAttribute('title');
              }
            }
          }
          removeTitles();
        });

        scope.__es_title_observer.observe(scope, { subtree: true, childList: true, attributes: true, attributeFilter: ['title', 'data-original-title'] });
      }
    } catch(e) {}
  }

  window.esStripQuickviewImageTitles = stripTitles;
})();
/* =========================================================
   ES QUICKVIEW ULTRA INVISIBLE SCROLLBAR (V9)
   Reveal right-column scrollbar only on hover / while scrolling.
   Safe no-op if the element isn't present.
   ========================================================= */
(function(){
  try{
    function bind(){
      try{
        if (window.innerWidth < 992) return;
        var el = document.querySelector('.quickview-product.tshopify-popup.active .content.product-quickview > .row > .col-5');
        if (!el) return;
        if (el.dataset.esUltraSbBound === '1') return;
        el.dataset.esUltraSbBound = '1';
        var t = null;
        el.addEventListener('scroll', function(){
          try{
            el.classList.add('es-qv-scrollbar-show');
            if (t) window.clearTimeout(t);
            t = window.setTimeout(function(){
              el.classList.remove('es-qv-scrollbar-show');
            }, 900);
          } catch(e){}
        }, { passive: true });
      } catch(e){}
    }

    document.addEventListener('swym:qv-loaded', function(){
      bind();
    });
  } catch(e){}
})();